import { AppShell, Loader, Select, Stack, ThemeIcon, Title } from "@mantine/core";
import { WarningIcon } from "@phosphor-icons/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { getSubLinksFrom, MenuItem } from "@/constants/navlinks";
import { HeaderMegaMenu, HeaderTabs } from "@/features/dashboard/_components/Header";
import { SelectedCompanyContext, SelectedCompanyProvider, useSelectedCompany } from "@/features/dashboard/configuracoes/_context/SelectedCompanyContext";
import { useIsMobile } from "@/hooks";
import { Role, useGetCompaniesQuery } from "@/store";
import { transformInOptions } from "@/utils";
import { requireRoles } from "@/utils/requiredRoles";

export const Route = createFileRoute("/_private/dashboard/_settings")({
  component: RouteComponent,
  beforeLoad: requireRoles({
    allowed: [Role.Administrador]
  })
});

function RouteComponent() {
  const { data, isLoading } = useGetCompaniesQuery(undefined, {
    selectFromResult: (state) => {
      return {
        ...state,
        data: transformInOptions(state.data)
      };
    }
  });

  const tabs = getSubLinksFrom(MenuItem.SETTINGS).map((item) => ({
    ...item,
    children: item.label
  }));

  const isMobile = useIsMobile();

  return (
    <SelectedCompanyProvider>
      <SelectedCompanyContext.Consumer>
        {({ companyId, setCompanyId }) => (
          <>
            <AppShell.Header>
              <HeaderTabs
                items={tabs}
                from="/dashboard/configuracoes"
                components={{
                  select: (
                    <Select placeholder="Selecione uma empresa" data={data} value={companyId} leftSection={isLoading && <Loader size="sm" />} onChange={setCompanyId} size="sm" />
                  )
                }}
              />
              {isMobile && <HeaderMegaMenu />}
            </AppShell.Header>

            <AppShell.Main>
              {companyId && <Outlet />}
              <SelectCompanyWarning />
            </AppShell.Main>
          </>
        )}
      </SelectedCompanyContext.Consumer>
    </SelectedCompanyProvider>
  );
}

function SelectCompanyWarning() {
  const { data, isLoading } = useGetCompaniesQuery(undefined, {
    selectFromResult: (state) => {
      return {
        ...state,
        data: transformInOptions(state.data)
      };
    }
  });
  const { companyId, setCompanyId } = useSelectedCompany();

  if (companyId) return null;

  return (
    <Stack align="center" justify="center" h="100%">
      <ThemeIcon size={128} variant="light" color="yellow" radius="100%">
        <WarningIcon size={64} />
      </ThemeIcon>

      <Title order={1} ta="center">
        Selecione uma empresa para continuar!
      </Title>

      <Select
        placeholder="Selecione uma Empresa"
        data={data}
        value={companyId}
        leftSection={isLoading && <Loader size="sm" />}
        onChange={setCompanyId}
        size="lg"
        className="w-[min(100%,600px)]!"
      />
    </Stack>
  );
}
